import HttpRequest from './HttpRequest';
import generateEndpoint from '../utils/generateEndpoint';

export default class PartnerLeadService extends HttpRequest {
  static endpoint = 'driver-leads';

  static async getAll() {
    this.endpoint = generateEndpoint('driver-leads');
    const response = await this.get();
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'driver-leads';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'driver-leads';
    const response = await this.delete(id);
    return response;
  }
}
